var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _path4, _path5, _path6, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#6C757D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1364 111V41.1818H78.8636C83.9091 41.1818 88.1023 41.9773 91.4432 43.5682C94.8068 45.1364 97.3182 47.2841 98.9773 50.0114C100.659 52.7386 101.5 55.8295 101.5 59.2841C101.5 62.125 100.955 64.5568 99.8636 66.5795C98.7727 68.5795 97.3068 70.2045 95.4659 71.4545C93.625 72.7045 91.5682 73.6023 89.2955 74.1477V74.8295C91.7727 74.9659 94.1477 75.7273 96.4205 77.1136C98.7159 78.4773 100.591 80.4091 102.045 82.9091C103.5 85.4091 104.227 88.4318 104.227 91.9773C104.227 95.5909 103.352 98.8409 101.602 101.727C99.8523 104.591 97.2159 106.852 93.6932 108.511C90.1705 110.17 85.7386 111 80.3977 111H52.1364ZM64.7841 100.432H78.3864C82.9773 100.432 86.2841 99.5568 88.3068 97.8068C90.3523 96.0341 91.375 93.7614 91.375 90.9886C91.375 88.9205 90.8636 87.0568 89.8409 85.3977C88.8182 83.7159 87.3636 82.3977 85.4773 81.4432C83.5909 80.4659 81.3409 79.9773 78.7273 79.9773H64.7841V100.432ZM64.7841 70.875H77.2955C79.4773 70.875 81.4432 70.4773 83.1932 69.6818C84.9432 68.8636 86.3182 67.7159 87.3182 66.2386C88.3409 64.7386 88.8523 62.9659 88.8523 60.9205C88.8523 58.2159 87.8977 55.9886 85.9886 54.2386C84.1023 52.4886 81.2955 51.6136 77.5682 51.6136H64.7841V70.875ZM124.196 111H110.696L135.276 41.1818H150.889L175.503 111H162.003L143.355 55.5H142.81L124.196 111ZM124.639 83.625H161.457V93.7841H124.639V83.625ZM173.193 51.7841V41.1818H228.898V51.7841H207.318V111H194.773V51.7841H173.193Z",
    fill: "#FAFAFD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112 225H362V396.708C362 405.544 354.837 412.708 346 412.708H128C119.163 412.708 112 405.544 112 396.708V225Z",
    fill: "#FAFAFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113 226H361V396.708C361 404.992 354.284 411.708 346 411.708H128C119.716 411.708 113 404.992 113 396.708V226Z",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112 239.95C112 231.693 118.693 225 126.95 225H347.05C355.307 225 362 231.693 362 239.95V239.95H112V239.95Z",
    fill: "#DDEAF8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 124.457,
    y: 258.223,
    width: 102.159,
    height: 137.043,
    fill: "url(#paint0_linear_106_416)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 322.965,
    y: 258.223,
    width: 26.5781,
    height: 89.701,
    fill: "url(#paint1_linear_106_416)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 389.453,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 366.195,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 377.824,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 354.566,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 293.105,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 304.734,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 316.363,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 327.988,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 281.477,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 258.223,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 269.852,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_416",
    x: 40.1367,
    y: 41.1836,
    width: 192.762,
    height: 85.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_416"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_416",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_416",
    x1: 126.909,
    y1: 257.807,
    x2: 192.356,
    y2: 394.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0AEBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_416",
    x1: 323.603,
    y1: 257.951,
    x2: 377.639,
    y2: 302.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0AEBA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBat);
export default __webpack_public_path__ + "static/media/bat.0dbb11c9aea0e4d0aeff97e96abe42b5.svg";
export { ForwardRef as ReactComponent };